<template>
  <div class="product-center-page-content-container">
    <div class="content-nav-bar">
      <ul>
        <li :class="{ active: active == 'zn' }" @click="activeChange('zn')">
          <img src="@/assets/images/zn-logo.png" alt="" />
          <span>众诺CRM</span>
        </li>
        <li :class="{ active: active == 'mly' }" @click="activeChange('mly')">
          <img src="@/assets/images/mly-logo.png" alt="" />
          <span>玛莉亚U+</span>
        </li>
        <li :class="{ active: active == 'crm' }">
          <img src="@/assets/images/crm-logo.png" alt="" />
          <span>管理平台+</span>
        </li>
      </ul>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "zn",
    };
  },
  methods: {
    activeChange(path) {
      this.active = path;
      this.$router.push(path);
    },
  },
  watch: {
    $route: {
      handler(newValue) {
        this.activeChange(newValue.name);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.product-center-page-content-container {
  .content-nav-bar {
    position: sticky;
    z-index: 99;
    top: 70px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #e9eef5;
    box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
    overflow: hidden;
    ul {
      display: flex;
      //   justify-content: center;
      //   align-items: center;
      li {
        width: 220px;
        height: 60px;
        @include btn;
        img {
          height: 30px;
          margin-right: 10px;
        }
        span {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #222222;
          line-height: 30px;
        }
      }
      li.active {
        position: relative;
        background-image: linear-gradient(180deg, #ffffff 0%, #f4f5fb 100%);
        // border-bottom: 4px solid #0764fb;
        &::after {
          position: absolute;
          bottom: 0;
          content: "";
          display: block;
          width: 100%;
          height: 4px;
          background: #0764fb;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productCenter/components/productContent.vue